import { GET_LAYOUT_REQUEST, GET_LAYOUT_SUCCESS, GET_LAYOUT_ERROR } from 'actions/layoutsActions';
import { REMOVE_FROM_CART } from 'actions/CartActions/UpdateCartActions';
import { ADD_TO_CART } from 'actions/CartActions/AddToCartActions';
import { AsyncStatus } from 'utils/asyncStatusHelper';

export default function layouts(
	state = {
		asyncStatus: AsyncStatus.INIT
	},
	action = null
) {
	const pageName = action.pageKey ? `${action.screenName}/${action.pageKey}` : action.screenName;

	switch (action.type) {
		case GET_LAYOUT_REQUEST:
			return Object.assign({}, state, {
				[pageName]: { asyncStatus: AsyncStatus.LOADING }
			});
		case GET_LAYOUT_SUCCESS:
			const ttl = state.ttl || {};
			if (!action.fromCache) {
				/* TODO: read from response */
				ttl[pageName] = new Date().getTime() + 1000 * 60;
			}

			return Object.assign({}, state, {
				ttl,
				[pageName]: Object.assign({ asyncStatus: AsyncStatus.SUCCESS }, action.data[pageName])
			});

		case GET_LAYOUT_ERROR:
			return Object.assign({}, state, {
				[pageName]: { asyncStatus: AsyncStatus.ERROR, error: action.error }
			});
		case ADD_TO_CART.SUCCESS:
		case REMOVE_FROM_CART.SUCCESS:
			let prevTtl = state.ttl || {};
			prevTtl['homepage'] = 0;
			return Object.assign({}, state, { ttl: prevTtl });
		default:
			return state;
	}
}
